import React from 'react';
import { Icon } from '@iconify/react';

function DropdownLanguage() {
	return (
		<div className="menu-item dropdown">
			<a href="#/" className="menu-link" data-bs-toggle="dropdown" aria-label="Choose language">
				<iconify-icon icon="solar:globus-bold-duotone"></iconify-icon>
			</a>
			<div className="dropdown-menu dropdown-menu-end">
				{[['us', 'English (US)'], ['es', 'Español'], ['fr', 'Français'], ['de', 'Deutsch'], ['jp', '日本語'], ['cn', '中文 (简体)'], ['br', 'Português (BR)']].map(([flag, name]) => (
					<div className="dropdown-item d-flex align-items-center gap-2" key={flag}><Icon icon={`flagpack:${flag}`} className="rounded-1 overflow-hidden fs-5 me-1" />{name}</div>
				))}
			</div>
		</div>
	);
};

export default DropdownLanguage;
